export const normalizeAssets = data => {

	const assets = {};

	Object
		.values(data)
		.forEach(x => {

			if (!x.dateAdded)
				x.dateAdded = '1970-01-01T00:00:00Z';

			assets[x._id] = x;
		});

	return assets;
};
